import React from 'react';
import ReactDOM from 'react-dom';
import ProviderApp from './ProviderApp';
import './bootstrap.min.css';

ReactDOM.render(
  <ProviderApp />,
  document.getElementById('root')
);
